import React from "react";
import { Button } from "antd";
import { CloseCircleFilled } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import { canUseSubscriptionFeatures } from "../../shared/billing";
import "./PaymentFailed.css";

export default function PaymentFailed() {
  const history = useHistory();
  const subscriptionFeaturesEnabled = canUseSubscriptionFeatures();

  return (
    <div className="payment-failed-page">
      <div className="payment-failed-card">
        <CloseCircleFilled className="payment-failed-icon" />

        <h1 className="payment-failed-title">Payment was not completed</h1>
        <p className="payment-failed-text">
          Your checkout was canceled or could not be completed. You can return
          to the dashboard and try again when you are ready.
        </p>

        <Button
          className="payment-failed-primary"
          onClick={() => history.push("/employerdashboard")}
        >
          Go to dashboard
        </Button>

        {subscriptionFeaturesEnabled && <button
          type="button"
          className="payment-failed-link"
          onClick={() => history.push("/transaction-history")}
        >
          View transaction history
        </button>}
      </div>
    </div>
  );
}
